import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { StaffOnly } from '@/features/admin-content/StaffOnly';
import { useCan } from '@/features/admin-content/use-current-user';
import { LessonsAdmin } from '@/features/staff-workspace/LessonsAdmin';

export const Route = createFileRoute('/admin/lessons')({
  component: AdminLessonsPage,
});

function AdminLessonsPage() {
  const allowed = useCan('content.admin');
  if (!allowed) {
    return (
      <StaffOnly title="You cannot open lessons" description="Ask an admin for staff access." />
    );
  }
  return (
    <div className="grid gap-6">
      <PageHeader
        eyebrow="Staff portal"
        title="Lessons"
        description="Strategy lessons students read and watch. A new lesson starts as a draft; an admin publishes it. If you change a live lesson, it goes back to draft until an admin publishes it again."
      />
      <LessonsAdmin />
    </div>
  );
}
